export function getImageDimension(
  image: Blob,
): Promise<{ width: number; height: number }> {
  return new Promise(resolve => {
    const url = URL.createObjectURL(image)
    const img = new Image()
    img.src = url

    img.onload = () => {
      URL.revokeObjectURL(url)
      resolve({ width: img.width, height: img.height })
    }
  })
}
